export const encodePathSegment = value => encodeURIComponent(String(value));

export default {
  encodePathSegment,
};



// WEBPACK FOOTER //
// ./src/utils/url.js